enum GameModalContent {
  CLOSE_TABLE = 1,
  RESIGN,
  ABORT_GAME,
  EMAIL_GAME,
}

export default GameModalContent;
